import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import fr from "./locales/fr/common.json";
import es from "./locales/es/common.json";
import ar from "./locales/ar/common.json";
import hi from "./locales/hi/common.json";

// =============================================================================
// i18n, starting with Cart10's five languages (spec §8). Every UI string goes
// through react-i18next from phase 1 — retrofitting translations later is how
// hardcoded English ends up permanent.
// =============================================================================

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "es", label: "Español", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "hi", label: "हिन्दी", dir: "ltr" },
] as const;

export type LangCode = (typeof LANGUAGES)[number]["code"];
export const SUPPORTED_LNGS: LangCode[] = LANGUAGES.map((l) => l.code);

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      fr: { common: fr },
      es: { common: es },
      ar: { common: ar },
      hi: { common: hi },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LNGS,
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "cart10mkt_lang",
    },
  });

/** Arabic flips the document to RTL. */
export function applyDirection(lng: string): void {
  const base = lng.split("-")[0] ?? "en";
  const dir = LANGUAGES.find((l) => l.code === base)?.dir ?? "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.dir = dir;
    document.documentElement.lang = base;
  }
}

applyDirection(i18n.language || "en");
i18n.on("languageChanged", applyDirection);

export default i18n;
